import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Story } from '@/models/story.model';
import { ShiftCMSState } from '@/store';
import { StoriesState } from '@/stores/stories.store';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'StoriesMenu',
  props: {
  item: {
    type: String,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { ts: StoriesState }>();
const story = computed<Story | null>(() => store.state.ts.story);

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { app: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_breadcrumbs, {
        items: [
        { title: 'Stories', to: '/stories' },
        props.item ? props.item : story.value ? `${story.value.title}` : 'List',
      ]
      }, null, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})